module.exports = __webpack_public_path__ + "img/logo-towers-small@2x.bcbcbcdb.png";